import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

const STATUS_LABEL = {
  pending_payment: { label: "Awaiting payment", bg: "var(--yellow)" },
  paid: { label: "Paid", bg: "var(--green)" },
  preparing: { label: "Preparing", bg: "var(--yellow)" },
  ready_for_pickup: { label: "Ready", bg: "var(--yellow)" },
  assigned: { label: "Driver assigned", bg: "var(--blue)" },
  picked_up: { label: "Picked up", bg: "var(--blue)" },
  delivering: { label: "On the way", bg: "var(--blue)" },
  delivered: { label: "Delivered", bg: "var(--green)" },
  cancelled: { label: "Cancelled", bg: "var(--red)" },
};

export default function OrdersHistory() {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data));
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <span className="label-eyebrow">Your history</span>
        <h1 className="mt-1 font-display text-5xl">Orders</h1>
      </div>
      {orders.length === 0 ? (
        <div className="card-panel p-10 text-center text-[var(--text-2)]">No orders yet.</div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => {
            const st = STATUS_LABEL[o.status] || { label: o.status, bg: "var(--text-2)" };
            return (
              <button
                key={o.order_id}
                onClick={() => navigate(`/orders/${o.order_id}`)}
                className="w-full card-panel p-5 flex items-center gap-4 text-left"
              >
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-bold text-[var(--text-3)] uppercase tracking-widest">
                    #{o.order_id.slice(-6).toUpperCase()} · {new Date(o.created_at).toLocaleDateString()}
                  </p>
                  <p className="mt-1 font-display text-xl">
                    {o.items.length} items · R{o.total.toFixed(2)}
                  </p>
                  <span
                    className="mt-2 inline-block px-3 py-0.5 rounded-full text-[11px] font-black uppercase tracking-widest text-white border-2 border-[var(--text)]"
                    style={{ background: st.bg }}
                  >
                    {st.label}
                  </span>
                </div>
                <ArrowRight size={18} weight="bold" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
